import { Transaction } from './transaction';

export class EvaluateServiceTransaction {
  serviceTransactionEvaluationId: number;
  destinationEvaluation: string;
  isDestinationComplete: boolean;
  sourceEvaluation: string;
  isSourceComplete: boolean;
  notes: string;
  transaction: Transaction = new Transaction();
}
